import { Camera, Object3D, Scene, Vector3 } from "three";
import { DeviceOrientationControls } from "three/examples/jsm/controls/DeviceOrientationControls";
import { PointerLockControls } from "three/examples/jsm/controls/PointerLockControls";
import CurrentPlayer from "../Player/CurrentPlayer";
import { IMovement } from "./Movement";

interface UserControls {
    scene: Scene;
    gameObject: CurrentPlayer;
    controls: DeviceOrientationControls | PointerLockControls; // TODO controls
    jumpPower: number;
    moveSpeed: number;
    movement: IMovement;
    canJump: boolean;
    initialiseControls: (showMenu: () => void, hideMenu: () => void) => void;
    update: (delta: number) => void;
    lock: () => void;
}

export default UserControls;

export function getYLockedRotation(model: Object3D, camera: Camera): Vector3 {
    const lookVector = new Vector3(0, 0, 1);
    lookVector.applyQuaternion(camera.quaternion);
    lookVector.setY(0);
    lookVector.normalize();

    lookVector.add(model.position);

    // TODO horrible side effect
    model.lookAt(lookVector);

    return new Vector3(model.rotation.x, model.rotation.y, model.rotation.z);
}
